module.exports = __webpack_public_path__ + "static/media/topBanner.b8ea1a9f.png";